import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class OmnisearchFilterItem extends Resource {
  public static type = 'omnisearch/filter_items';

  @prop
  public label: string;

  @prop
  public value: number;

  @prop
  public amount: number;
}
